// extracted by mini-css-extract-plugin
export var mt0 = "quote-module--mt-0--4f533";
export var mt1 = "quote-module--mt-1--2048a";
export var mt2 = "quote-module--mt-2--db621";
export var mt3 = "quote-module--mt-3--3020a";
export var mt4 = "quote-module--mt-4--71243";
export var mt5 = "quote-module--mt-5--b3061";
export var mt6 = "quote-module--mt-6--926d7";
export var quote = "quote-module--quote--9e53a";
export var quoteDark = "quote-module--quote--dark--7b728";
export var quoteOnForm = "quote-module--quote--on-form--a57c2";
export var quoteTransparent = "quote-module--quote--transparent--a9627";
export var quoteWithImage = "quote-module--quote--with-image--257af";
export var quote__author__name = "quote-module--quote__author__name--fe345";
export var quote__author__role = "quote-module--quote__author__role--3bd78";
export var quote__avatar = "quote-module--quote__avatar--71d1e";
export var quote__blockquote = "quote-module--quote__blockquote--0675f";
export var quote__caption = "quote-module--quote__caption--27fa5";
export var quote__contentWrapper = "quote-module--quote__content-wrapper--bccc5";
export var quote__icon = "quote-module--quote__icon--c0a88";
export var quote__largeImage = "quote-module--quote__large-image--94f44";
export var quote__largeImageWrapper = "quote-module--quote__large-image-wrapper--b7fb0";
export var quote__largeImage__content = "quote-module--quote__large-image__content--d790a";